import { gql, useQuery } from '@apollo/client';

import type { GetSensorConfigForTaskQuery } from '@sbrc/gql/apollo-codegen';

const getSensorConfigQuery = gql`
  query GetSensorConfigForTask($taskId: String!) {
    getTrainingDataTaskSensorsConfig(taskId: $taskId) {
      id
      equipmentName
      sensorType
      dataType
      isSecondary
      metadata
    }
  }
`;

// Define the actual sensor config structure from the protobuf
export interface SensorConfigData {
  id: string;
  equipmentName: string;
  sensorType: string;
  dataType: string;
  isSecondary: boolean;
  metadata?: string; // JSON string
}

export interface UseSensorConfigReturn {
  sensors: SensorConfigData[];
  isLoading: boolean;
  error: string | null;
}

/**
 * Hook to fetch training data tasks from the server
 * Returns:
 * - tasks: list of available tasks
 */
export function useSensorConfig(taskId: string | null): UseSensorConfigReturn {
  const {
    data: sensorsData,
    loading: sensorsLoading,
    error: sensorsError,
  } = useQuery<GetSensorConfigForTaskQuery>(getSensorConfigQuery, {
    variables: { taskId },
    skip: !taskId, // Only run query if taskId is provided
  });

  const sensors = sensorsData?.getTrainingDataTaskSensorsConfig ?? [];

  return {
    sensors,
    isLoading: sensorsLoading,
    error: sensorsError?.message || null,
  };
}
